<template>
  <b-alert
    v-model="dismissCountDown"
    class="position-fixed fixed-bottom m-0 rounded-0"
    style="z-index: 2000;"
    variant="warning"
    dismissible
    @dismissed="dismissCountDown=0"
    @dismiss-count-down="countDownChanged"
  >
    <span>{{ messageToRevert }}</span>
    <a
      @click.prevent="prepareForRevertAction"
      class="text-primary"
      :title="$t('undo')"
    >
      {{ $t('undo') }}
    </a>
  </b-alert>
</template>
<script>
import { mapGetters } from 'vuex'
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  name: 'v-revert-changes-alert',
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    dismissSecs: 6,
    dismissCountDown: 0,
    reverted: false,
  }),
  computed: {
    ...mapGetters([
      'requestToRevert',
      'messageToRevert',
      'alternativeUrlToRevert',
    ]),
  },
  mounted: function () {
    this.$root.$on('triggerSwitchRevertDataToast', async (state, data = null)  => {
      if (state) {
        if (this.checkVariable(data)) {
          await this.captureAditionalDataToRevert(data)
        }

        this.showAlert()
      } else {
        this.dismissCountDown = 0
        this.reverted = true
      }
    })
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
      this.reverted = false
    },
    prepareForRevertAction() {
      const finalUrl = this.checkVariable(this.alternativeUrlToRevert) ? this.alternativeUrlToRevert : this.url
      this.revertAction(finalUrl, this.requestToRevert)
    },
    async captureAditionalDataToRevert(data) {
      await this.$store.dispatch('captureAdditionalRecordData', data)
    },
  },
}
</script>
